<template lang="pug">
span.legend
  span test
  span this
</template>
<script>
export default {
  props: ['text']
}
</script>
